import { Breadcrumb, type BreadcrumbProps } from 'antd';
import classnames from 'classnames';
import classes from './index.module.scss';
import { useSnapshotBreadcrumbs } from '@/stores/breadcrumbs';

interface ICustomButton extends BreadcrumbProps {}

// 面包屑间隔符号
const BREADCRUMB_SEPARATOR = '>';

function CustomBreadcrumb(props: ICustomButton) {
  const { className, ...rest } = props;
  const { breadcrumbs } = useSnapshotBreadcrumbs();

  return (
    <Breadcrumb
      className={classnames(classes.wrap, className)}
      separator={BREADCRUMB_SEPARATOR}
      items={breadcrumbs}
      {...rest}
    />
  );
}

export default CustomBreadcrumb;
